import Loader from "react-loader-spinner";
import styles from "./ProcessingAsset.module.css";
import React from "react";

const ProcessingAsset = (props: any) => (
    <div className={styles.mediumCard}>
        <div className={styles.cardCenter}>
            <div>
                <Loader type="Oval" color="#B4B4B4" height={84} width={87} />
                <b className={styles.text}> Processing Report </b>
            </div>
        </div>
    </div>
);
export default ProcessingAsset;
